import type { ShipyardOrderCommand, ShipyardOverview, ShipyardQuote, ShipyardQuoteQuery, ShipOrderClient } from '@galaxis/shared';
import { apiFetch } from './client.ts';

/** Fleet-view shipyard: every price, time and rule comes from the server. */
export const fetchShipyard = (): Promise<ShipyardOverview> => apiFetch('/shipyard');

export function fetchShipyardQuote(q: Omit<ShipyardQuoteQuery, 'quantity'> & { quantity: number }): Promise<ShipyardQuote> {
  const p = new URLSearchParams({ systemId: q.systemId, shipClass: q.shipClass, quantity: String(q.quantity) });
  if (q.weapon) p.set('weapon', q.weapon);
  if (q.module) p.set('module', q.module);
  if (q.targetFleetId) p.set('targetFleetId', q.targetFleetId);
  return apiFetch(`/shipyard/quote?${p.toString()}`);
}

export const orderShips = (cmd: ShipyardOrderCommand): Promise<{ orders: ShipOrderClient[] }> =>
  apiFetch('/shipyard/orders', { method: 'POST', body: JSON.stringify(cmd) });
